import { useRef, useState } from "react";
import { useVerifiedOnboarding } from "../../onboard-verify/verified-onboarding-context.ts";
import { showError, showSuccess } from "../../../../utils/toast.ts";
import { submitOnboardingForm, type SubmissionFiles, type SubmissionValues } from "./submission-api.ts";

export function useOnboardingSubmission(recipient: "consultant" | "agency") {
  const verified = useVerifiedOnboarding();
  const locked = useRef(false);
  const [busy, setBusy] = useState(false);
  const [complete, setComplete] = useState(false);
  const submit = async (values: SubmissionValues, files: SubmissionFiles) => {
    if (locked.current) return false;
    locked.current = true;
    setBusy(true);
    try {
      if (!verified?.token) throw new Error("Open your invitation link and verify your email before submitting.");
      const emailKey = recipient === "agency" ? "email" : "personalEmail";
      if (values[emailKey] && values[emailKey]?.trim().toLowerCase() !== verified.email.trim().toLowerCase()) {
        throw new Error("Your email must match the verified invitation email.");
      }
      const { data } = await submitOnboardingForm(recipient, verified.token, { ...values, [emailKey]: verified.email }, files);
      setComplete(true);
      showSuccess(data?.message || "Your onboarding form was submitted successfully.");
      return true;
    } catch (error) {
      showError(error instanceof Error ? error.message : "Unable to submit your form. Please try again.");
      locked.current = false;
      return false;
    } finally {
      setBusy(false);
    }
  };
  return { verified, busy, complete, submit };
}
